import { useLiveQuery } from "dexie-react-hooks";
import { useCallback } from "react";
import { draftDB } from "./db";
import type { DraftSaveResponse } from "./schema";

export function useAllDrafts(projectId: number) {
  return useLiveQuery(() => draftDB.dailyLogDrafts.where("project_id").equals(projectId).toArray(), [projectId]);
}

export function useDraftStore(draftId: string, projectId: number) {
  // `undefined` = 아직 IndexedDB 조회 전, `null` = 조회 완료·레코드 없음.
  // 두 상태를 구분해야 "드래프트가 없다"와 "아직 모른다"를 혼동하지 않는다.
  const draft = useLiveQuery(() => draftDB.dailyLogDrafts.get(draftId).then((d) => d ?? null), [draftId]);

  const getDraft = useCallback(() => draftDB.dailyLogDrafts.get(draftId), [draftId]);

  const upsert = useCallback(
    async (data: DraftSaveResponse) => {
      await draftDB.dailyLogDrafts.put({ ...data, project_id: projectId });
    },
    [projectId],
  );

  const remove = useCallback(async () => {
    await draftDB.dailyLogDrafts.delete(draftId);
  }, [draftId]);

  return {
    draft,
    getDraft,
    upsert,
    remove,
  } as const;
}
